import { parsePositiveInteger } from '@helpers/parsing';
import React, { Component, KeyboardEvent } from 'react';
import CreatableSelect from 'react-select';

export enum ValueType {
  Text,
  Integer
}

interface Props {
  valueType?: ValueType;
  name: string;
  values: any[];
  isDisabled?: boolean;
  placeholder?: string;
  onChange: (newValues: any[]) => void;
}

interface State {
  inputValue: string;
}

const components = {
  DropdownIndicator: null
};

class ValueListInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      inputValue: ''
    };
  }

  public render() {
    const { inputValue } = this.state;
    const { isDisabled, name, values, placeholder } = this.props;

    const options = values.map(v => ({
      label: v.toString(),
      value: v
    }));

    return (
      <CreatableSelect
        id={name}
        name={name}
        isDisabled={isDisabled}
        components={components}
        inputValue={inputValue || ''}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
        placeholder={placeholder}
        value={options}
      />
    );
  }

  private handleChange = (value: any, actionMeta: any) => {
    let newValue = value;

    switch (actionMeta.action) {
      case 'remove-value':
        newValue = newValue.filter(v => v !== actionMeta.removedValue);
    }

    this.props.onChange(newValue.map(v => v.value));
  };

  private handleInputChange = (inputValue: string) => {
    if (!inputValue) {
      this.setState({ inputValue: null });
    }

    if (this.props.valueType === ValueType.Integer) {
      const numberValue = parsePositiveInteger(inputValue);
      this.setState({ inputValue: numberValue ? numberValue.toString() : null });
      return;
    }

    this.setState({ inputValue });
  };

  private handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    const { inputValue } = this.state;
    const { values } = this.props;

    if (!inputValue) {
      return;
    }
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        event.stopPropagation();
        event.preventDefault();

        this.setState({ inputValue: '' }, () => {
          const newValue =
            this.props.valueType === ValueType.Integer ? parsePositiveInteger(inputValue) : inputValue.trim();
          this.props.onChange([...values, newValue]);
        });
    }
  };
}

export default ValueListInput;
